import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import styled, { createGlobalStyle } from "styled-components";
import { init } from "@noriginmedia/norigin-spatial-navigation";
import { Menu } from "../layout/sidebar";
import ArtistContent from "./content";

init({
  debug: false,
  visualDebug: false,
  rtl: true,
});

const GlobalStyle = createGlobalStyle`
  ::-webkit-scrollbar {
    display: none;
  }
`;

const AppContainer = styled.div`
  background: #121212;
  width: 100vw;
  height: 100vh;
  display: table;
  table-layout: fixed;
  direction: rtl;
`;

const SidebarCell = styled.div`
  display: table-cell;
  width: 250px;
  min-width: 250px;
  max-width: 250px;
  vertical-align: top;
  height: 100vh;
`;

const ContentCell = styled.div`
  display: table-cell;
  width: calc(100vw - 250px);
  vertical-align: top;
  height: 100vh;
  overflow: visible;
`;

export default function SpitialArtist({ data }) {
  return (
    <AppContainer>
      <GlobalStyle />
      <SidebarCell>
        <Menu focusKey="MENU" />
      </SidebarCell>
      <ContentCell>
        <ArtistContent data={data} />
      </ContentCell>
    </AppContainer>
  );
}

